import { useState as n, useCallback as l } from "react";
const f = (r) => {
  const [s, e] = n(void 0), [c, o] = n("default"), i = l(
    async (...u) => {
      e(void 0), o("loading");
      try {
        return await r(...u);
      } catch (t) {
        const a = t instanceof Error ? t : new Error(`${t}`);
        throw e(a), a;
      } finally {
        o("default");
      }
    },
    [r]
  );
  return {
    loadingState: c,
    error: s,
    execute: i
  };
};
export {
  f as useRequester
};
